<div class="wrapper">
  @if (this.recordsTableColumnsParams && recordsTableData) {
    @if (hasFilters) {
      <div class="filters-container">
        <app-records-table-filters
          [filtersParams]="recordsTableColumnsParams"
          [resourceParams]="resourceParams"
          (filtersChanged)="changeFiltersParams($event)"
          (toggleFiltersVisible)="toggleFiltersVisible()"
        />
      </div>
    }

    <div
      class="controls-container"
      [class.without-filters]="!hasFilters"
    >
      <app-records-table-toolbar
        #controlsComponent
        [isNewRecordDataValid]="isNewRecordDataValid()"
        [recordTableActions]="recordsTableActions"
        [resourceParams]="resourceParams"
        [currentZoomOption]="currentZoomOption"
        [selectedRowId]="selectedRowStateService.selectedRowId()"
        (updateQueryParams)="updateQueryParams($event)"
        (editModeStateChange)="handleEditModeStateChange($event)"
        (addRecordStateChanged)="handleAddRecordStateChange($event)"
        (saveRecordButtonClicked)="saveNewRecord()"
        (zoomChanged)="handleZoomChange($event)"
        (actionSelected)="handleActionSelect($event)"
        (refreshTable)="refreshTable()"
        (addCooperationOffer)="handleAddCooperationOffer()"
        (addUser)="handleAddUser()"
        (addPriceLevelConfig)="handleAddPriceLevelConfig()"
        (addTelegramAccount)="handleAddTelegramAccount()"
        (createBloggerGroup)="handleCreateBloggerGroup()"
        (openBloggerGroups)="handleOpenBloggerGroups()"
        (openSendMassOffers)="handleSendMassOffers()"
        (createComponent)="handleCreateComponent()"
        (createTestingResult)="handleCreateTestingResult()"
        (createQualityControl)="handleCreateQualityControl()"
      />
    </div>

    <div class="table-wrapper">
      @if (isLoading) {
        <app-loader/>
      }

      <app-records-table-view
        #recordsTableViewComponent
        class="records-table-view"
        [class]="{
          'full-height': isFullHeight,
          'product-card-full-height': isProductCardFullHeight
        }"
        [tableColumnsParams]="recordsTableColumnsParams"
        [tableActions]="recordsTableActions"
        [tableData]="recordsTableData"
        [tableTotals]="recordsTotalData"
        [resourceParams]="resourceParams"
        (sortParamsChanged)="changeSortParams($event)"
        (recordUpdated)="handleRecordUpdate($event)"
        (recordDeleted)="handleRecordDelete($event)"
        (reloadTableData)="reloadTableData()"
      />
      <app-records-table-paginator
        #paginatorComponent
        [tableData]="recordsTableData"
        [resourceParams]="resourceParams"
        (recordTableUpdated)="updateRecordTableData()"
      />
    </div>
  }
</div>
